import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import {Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel, ActivatedRoute} from '@angular/router';
import { filter, map } from 'rxjs';
import { environment } from '../environments/environment';
import { AuthenticationService } from './core/services/authentication.service';
import { CurrencyLocaleService } from './core/services/currency-locale.service';
import { UtilityService } from './core/utils/utility.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {
  cookieMessage = "This website uses cookies to provide necessary site functionality and improve your online experience. By using this website, you agree to the use of cookies as outlined in our online privacy policy. You can update your preferences manage preferences."
  isLoading = false;
  currentMarket:string
  companyInfo:any

  constructor(
    private router: Router,
    private authenticate: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private title: Title, 
    private utilityService: UtilityService,
    private localeCurrencyService: CurrencyLocaleService
  ) {
    if(router.url !== 'app/flights') {
      this.router.events.pipe()
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isLoading = true;
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.isLoading = false;
        }
      });
    }
    activatedRoute.queryParams.subscribe(res => {
      if (res.referralcode) {
        localStorage.setItem('referralcode', res.referralcode);
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  ngOnInit(): void {
    //this.getCompanyConfig();
    this.setPageTitle();
    
    //Set the currency for the user location
    this.localeCurrencyService.setLocaleCurrency()
    // let cc = window as any;
    // cc.cookieconsent.initialise({
    //   palette: {
    //     popup: {
    //       background: "#164969"
    //     },
    //     button: {
    //       background: "#ffe000",
    //       text: "#164969"
    //     }
    //   },
    //   theme: "classic",
    //   content: {
    //     message: this.cookieMessage,
    //     link: 'Learn more',
    //     dismiss: "Accept",
    //     href: "/app/privacy-policy"
    //   }
    // });
  }

  ngOnDestroy() {
    sessionStorage.clear();
    localStorage.clear();
  }

  getCompanyConfig() {
    this.companyInfo = this.utilityService.companyConfig;
    document.documentElement.style.setProperty('--primary-color', this.companyInfo.theme.colors.primary);
    document.documentElement.style.setProperty('--primary-r', this.companyInfo.theme.colors.rgbPrimary.r);
    document.documentElement.style.setProperty('--primary-g', this.companyInfo.theme.colors.rgbPrimary.g);
    document.documentElement.style.setProperty('--primary-b', this.companyInfo.theme.colors.rgbPrimary.b);
    this.setUserMarket(this.companyInfo.market);  
    this.getHomePageContent();
  }

  getHomePageContent() {
    this.utilityService.getHomePageContent().subscribe({
      next: (res: any) => {
        console.log('Home Content', res.data)
        localStorage.setItem("homePageContent", JSON.stringify(res.data))
      },
      error: () => {}
    });
  }

  private setPageTitle(): void {
    const companyInfo= this.utilityService.companyConfig;
    const defaultPageTitle = companyInfo.company.name;
    let pageTitleDesc = companyInfo.company.title
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;

        if (!child) {
          return this.activatedRoute.snapshot.data.title || defaultPageTitle;
        }

        while (child.firstChild) {
          child = child.firstChild;
        }
        // this.authenticate.authenticate().subscribe({
        //   next : (res)=>{}
        // })
        if (child.snapshot.data.title) {
          return child.snapshot.data.title || defaultPageTitle;
        }
      })
    ).subscribe((title: string) => this.title.setTitle(pageTitleDesc));
  }

  private setUserMarket(companyMarkets) {
    const defaultMarket = companyMarkets.find(x => x.countryName === 'Nigeria');
    this.router.events.pipe().subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
        let urlSplit = event.url.split('/');

        if(urlSplit.length == 2 ) {
          const market = urlSplit[1];
          const marketExists = companyMarkets.some(x => x.country == market.toLowerCase());
          this.currentMarket = marketExists ? market.toLowerCase() : localStorage.getItem('market') ?? defaultMarket.country 
          console.log('Current Market', this.currentMarket)
          localStorage.setItem('market', this.currentMarket);
          let marketInfo = companyMarkets.find(x => x.country == this.currentMarket);
          localStorage.setItem('marketParams', JSON.stringify(marketInfo))
          if(!marketExists) this.router.navigate([this.currentMarket]);
        }
        // else if (urlSplit.length > 2) {
        //   const urlRef = urlSplit.slice();
        //   const market = localStorage.getItem('market') ?? 'ng';

        //   // Check if the second part of the URL is already the market
        //   const alreadyHasMarket = companyMarkets.some(
        //     x => x.country.toLowerCase() === urlRef[1]?.toLowerCase()
        //   );

        //   if (!alreadyHasMarket) {
        //     // Only insert if it's not already there
        //     urlRef.splice(1, 0, market);
        //     const newUrl = urlRef.join('/');
        //     console.log('URL', [newUrl]);
        //     this.router.navigate([newUrl], { replaceUrl: true }); // replaceUrl prevents infinite loop
        //   } else {
        //     console.log('Nothing', urlRef);
        //   }
        // }
        else if (urlSplit.length > 2) {
          const urlRef = urlSplit.slice();
          const market = (localStorage.getItem('market') ?? 'ng').toLowerCase();

          // if the URL already starts with a market, don't touch it
          if (urlRef[1]?.toLowerCase() === market) {
            console.log('Nothing', urlRef);
            return;
          }

          // Check against allowed company markets
          const alreadyHasMarket = companyMarkets.some(
            x => x.country.toLowerCase() === urlRef[1]?.toLowerCase()
          );

          if (!alreadyHasMarket) {
            urlRef.splice(1, 0, market);
            const newUrl = urlRef.join('/');
            console.log('URL', [newUrl]);

            this.router.navigate([newUrl], { replaceUrl: true });
          } else {
            console.log('Nothing', urlRef);
          }
        }
      }
    })
  }
}
